import { Paper } from '../../atoms/Paper';
import { Text } from '../../atoms/Text';
import { Stack } from '../../atoms/Stack';
import type { CoreProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export interface StatCardProps extends CoreProps {
  label: string;
  value: string | number;
  hint?: string;
}

export function StatCard({ label, value, hint, testId, view = 'all' }: StatCardProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return (
    <Paper p="md" withBorder data-testid={testId}>
      <Stack gap={4}>
        <Text size="sm" c="dimmed">
          {label}
        </Text>
        <Text fw={700} size="xl">
          {value}
        </Text>
        {hint ? (
          <Text size="xs" c="dimmed">
            {hint}
          </Text>
        ) : null}
      </Stack>
    </Paper>
  );
}
